import { useEffect } from "react";
import { toast } from "sonner";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { consumeLegacyRedirectOrigin } from "@/lib/legacyRedirect";

const messages = {
  en: { title: "URL updated", body: "Our page addresses no longer use “.html”. You’ve been sent to the new clean URL." },
  nl: { title: "URL bijgewerkt", body: "Onze pagina-adressen gebruiken geen “.html” meer. Je bent doorgestuurd naar de nieuwe schone URL." },
  es: { title: "URL actualizada", body: "Las direcciones ya no usan “.html”. Te hemos redirigido a la nueva URL." },
  de: { title: "URL aktualisiert", body: "Unsere Seitenadressen verwenden kein „.html“ mehr. Du wurdest zur neuen URL weitergeleitet." },
  fr: { title: "URL mise à jour", body: "Nos adresses n’utilisent plus « .html ». Vous avez été redirigé vers la nouvelle URL." },
  it: { title: "URL aggiornato", body: "I nostri indirizzi non usano più “.html”. Sei stato reindirizzato al nuovo URL." },
  pt: { title: "URL atualizado", body: "Os nossos endereços já não usam “.html”. Foi redirecionado para o novo URL." },
  dk: { title: "URL opdateret", body: "Vores sideadresser bruger ikke længere “.html”. Du er sendt til den nye URL." },
} as const;

export const LegacyUrlNotice = () => {
  const { language } = useLanguage();

  useEffect(() => {
    const original = consumeLegacyRedirectOrigin();
    if (!original) return;
    const m = messages[language as keyof typeof messages] || messages.en;
    toast(m.title, {
      description: `${m.body} (${original})`,
      duration: 6000,
    });
  }, [language]);

  return null;
};
